import script from "./MetaInfo.vue?vue&type=script&lang=ts"
export * from "./MetaInfo.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__